import { useEffect } from "react";
import "@/pages/Enquire.css";

/* ------------------------------------------------------------------
   TALLY REDIRECT NOTE
   ------------------------------------------------------------------
   The post-submission redirect (to /thank-you) must be configured
   inside the Tally form settings:
     Form Settings → After submission → Redirect to a URL
     URL: https://<this-site-domain>/thank-you
   This cannot be controlled from the embed code.
   ------------------------------------------------------------------ */

const TALLY_SCRIPT_SRC = "https://tally.so/widgets/embed.js";
const TALLY_EMBED_URL =
  "https://tally.so/embed/EkZK1X?alignLeft=1&hideTitle=1&dynamicHeight=1";

export default function Enquire() {
  useEffect(() => {
    document.title = "Enquire — Ōraṇi";
    window.scrollTo(0, 0);

    // Load Tally embed script once, then ask it to (re)hydrate any
    // iframes carrying a data-tally-src attribute on this page.
    const hydrate = () => {
      if (window.Tally && typeof window.Tally.loadEmbeds === "function") {
        window.Tally.loadEmbeds();
      }
    };

    const existing = document.querySelector(
      `script[src="${TALLY_SCRIPT_SRC}"]`
    );
    if (existing) {
      hydrate();
      return;
    }

    const script = document.createElement("script");
    script.src = TALLY_SCRIPT_SRC;
    script.async = true;
    script.onload = hydrate;
    document.body.appendChild(script);
  }, []);

  return (
    <main className="enquire" data-testid="enquire-root" aria-label="Enquire">
      <section className="enquire__inner">
        <span className="enquire__eyebrow" data-testid="enquire-eyebrow">
          Enquire
        </span>
        <h1 className="enquire__title" data-testid="enquire-title">
          Begin a Conversation
        </h1>
        <div className="enquire__lede" data-testid="enquire-lede">
          <p>
            Because we put a great deal of care into every home, we read
            each enquiry thoughtfully.
          </p>
          <p>
            Tell us about the space, where you are in the process, and what
            you are hoping to create. The details help us begin with the
            right questions.
          </p>
        </div>

        <div className="enquire__form" data-testid="enquire-form">
          <iframe
            data-tally-src={TALLY_EMBED_URL}
            loading="lazy"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Ōraṇi Enquiry Form"
            data-testid="enquire-tally-iframe"
          />
        </div>
      </section>
    </main>
  );
}
